// Featured projects for the homepage "Selected work" section.
//
// VERIFIED INFORMATION ONLY. Client names and links come from the owner and
// the published client list in components/PortfolioSlider.jsx.
//
// `challenge`, `delivered` and `outcome` render only when filled in.
// Leave them empty until Jason confirms the details for each client.
// Never add metrics, testimonials or results that cannot be evidenced.

import spectrumWriting from "../assets/work/spectrum-writing.webp"
import morningside from "../assets/work/morningside-chiropractic.webp"
import jesseBTattoos from "../assets/work/jesse-b-tattoos.webp"
import pinnocks from "../assets/work/pinnocks-charity.webp"
import midwayRoad from "../assets/work/midway-road-community-house.webp"
import cherryCreek from "../assets/work/cherry-creek-co.webp"

// Homepage selection, in the owner-specified order. Screenshots are of each
// live homepage (captured 2026-10-16), except Cherry Creek Co: its screenshot
// shows 2merative's new site, captured from the temporary Hostinger preview
// because www.cherrycreekco.com.au switches to it shortly. Links are as
// supplied by the owner (the preview URL is intentionally not linked).
const project = (client, liveLink, image) => ({ client, liveLink, image, challenge: "", delivered: "", outcome: "" })

export const FEATURED_PROJECTS = [
  project("Spectrum Writing", "https://www.spectrumwriting.com.au/", spectrumWriting),
  project("Morningside Chiropractic", "https://www.morningsidechiro.com.au/", morningside),
  project("Jesse B Tattoos", "https://jessebtattoos.com.au/", jesseBTattoos),
  project("Pinnocks Charity", "https://pinnocks.org/", pinnocks),
  project("Midway Road Community House", "https://midwayroadcommunityhouse.com.au/", midwayRoad),
  project("Cherry Creek Co", "https://www.cherrycreekco.com.au/", cherryCreek),
]
